// El aviso de que el servidor se está despertando (roadmap móvil).
//
//     node scripts/prueba_despertador.mjs            (desde frontend/)
//
// QUÉ PASA. El servidor duerme cuando lleva un rato sin que entre nadie, y la primera petición
// después tarda lo que tarda en arrancar: hasta un minuto. En el ordenador del aula casi no se
// nota, porque alguien lo ha despertado antes. En el móvil, a las diez de la noche, el primero en
// entrar es justo el que lo nota: la pantalla se queda en el punto de «cargando» sin decir nada,
// y a los cinco segundos se va. **Una espera sin explicación es una web rota.**
//
// LO QUE HACE: si una petición lleva cuatro segundos sin respuesta y TODAVÍA NO HA CONTESTADO
// NADA, se avisa —«el servidor se está despertando»— y se quita sola con la primera respuesta.
// Se arma solo mientras el servidor no ha contestado en esta visita, o cuando lleva catorce
// minutos sin contestar a nada (el móvil que vuelve de segundo plano): una pregunta al mentor
// que tarda ocho segundos con el servidor despierto no es un servidor dormido, y avisar ahí
// sería mentir.
//
// LO QUE NO HACE, Y ES A PROPÓSITO: PONER UN TIEMPO LÍMITE CORTO A LAS PETICIONES. Era la idea
// de la auditoría —15 segundos— y sale al revés: el arranque tarda más que eso, así que la
// primera petición caería por tiempo, contaría como fallo en `systemStatusStore`, y a la
// segunda saldría la pantalla de reconexión… para un servidor que estaba a punto de contestar.
// Además el mentor y las importaciones del CMS tardan de verdad. Mejor esperar diciendo por qué.
//
// Y NO HACE FALTA UN «PING» EN LA PORTADA: `AuthContext` pregunta `/auth/me` al abrir cualquier
// página, la portada incluida, y esa pregunta ya es la que despierta al servidor.
//
// PURO: el reloj, el aviso y el silencio entran de fuera. Así se prueba en node sin esperar.

export const ESPERA_MS = 4000;
/** Lo que tarda el servidor en dormirse sin visitas, con un minuto de margen. */
export const SE_DUERME_MS = 14 * 60 * 1000;

export function creaDespertador({
  avisa, calla, ahora = () => Date.now(),
  arma = (f, ms) => setTimeout(f, ms), desarma = (t) => clearTimeout(t),
  espera = ESPERA_MS, seDuerme = SE_DUERME_MS,
} = {}) {
  let ultima = 0;          // cuándo contestó el servidor por última vez (0 = nunca)
  let reloj = null;
  let avisando = false;

  const dormido = () => !ultima || ahora() - ultima > seDuerme;

  return {
    /** Sale una petición. */
    sale() {
      if (reloj || avisando || !dormido()) return;
      reloj = arma(() => {
        reloj = null;
        if (dormido() && !avisando) { avisando = true; try { avisa?.(); } catch { /* da igual */ } }
      }, espera);
    },
    /** Ha contestado el servidor, con lo que sea: un 401 o un 500 también es estar despierto. */
    contesta() {
      ultima = ahora();
      if (reloj) { desarma(reloj); reloj = null; }
      if (avisando) { avisando = false; try { calla?.(); } catch { /* da igual */ } }
    },
    get avisando() { return avisando; },
  };
}
